import { render, staticRenderFns } from "./loadPipeAdd.vue?vue&type=template&id=0625fb5c&"
import script from "./loadPipeAdd.vue?vue&type=script&lang=js&"
export * from "./loadPipeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports